import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, EventEmitter, Inject, Input, OnChanges, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormDataService } from '@app/_core/services/form-data.service';
import { LoaderService } from '@app/_core/services/loader.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { ChildComponent } from '../case-detail.component';
import { QueuesService } from '@app/_core/services/queues.service';
import { AppService } from '@app/_core/services/app.service';
import { WindowsWrapperService } from '@app/_core/services/windows-wrapper.service'
import { DialerService } from '@app/_core/services/dialer.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { Utils } from '@app/_core/helper/Utils';
import { Router } from '@angular/router';
import { Queue } from 'src/app/pages/queue/dialer/Queue';
import { ConfigService } from '@app/config.services';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
export interface Field {
  fieldType: string;
  fileAttribute: string | null;
  isAlphaNumeric: boolean;
  isEmail: boolean;
  isMobile: boolean;
  isRegex: boolean;
  isRequired: boolean;
  maxLength: number | null;
  minLength: number | null;
  pattern: string;
  value: string;
  Name: string;
  Label: string;
  fieldID: any;
  dateAttribute: any;
  viewMode: boolean;
  isFromAPI: boolean;
  fieldOptions: [];
}

@Component({
  selector: 'app-user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.scss'],
})
export class UserInformationComponent implements OnInit, OnChanges, ChildComponent {
  @Input() conf: any;
  @Input() caseDetailsConf: any;
  @Input() tabName: any;
  @Input() ReadOnly: boolean;
  @Input() searchMemberObject: any;
  @Input() showChangeUser: boolean;
  @Output() formDataEmitter = new EventEmitter<any>();
  @Output() formDataHasError = new EventEmitter<any>();
  @Output() ConfirmUserNav: EventEmitter<boolean> = new EventEmitter<boolean>();
  isEdit: any = false;
  visible: boolean = false;
  display: any = 'none';
  field: Field = {
    fieldID: null,
    fieldType: 'Input',
    viewMode: true,
    isFromAPI: true,
    fileAttribute: null,
    isAlphaNumeric: false,
    isEmail: false,
    isMobile: false,
    isRegex: false,
    isRequired: false,
    maxLength: null,
    minLength: null,
    pattern: '',
    value: '',
    Name: '',
    Label: '',
    dateAttribute: null,
    fieldOptions: [],
  };

  newField: Field = this.field;
  subheadings: any;
  modalGroupObj: any;
  formData: any = {};
  activityId: any;
  companyCode: any;
  isCallConnected: boolean = false;
  fieldsReadOnly: boolean = false;
  isAddNewUser:boolean = false;
  IsUserChange: boolean = false;
  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private loaderService: LoaderService,
    private queueService: QueuesService,
    private appService: AppService
    , private WindowsWrapper: WindowsWrapperService,
    private dialerService: DialerService,
    private webStorageService: WebStorageService,
    private router: Router,
    private tmQueueService: TmQueueService,
    private configService: ConfigService,
    private flexStore: FlexibleStoreService,
    private mainController: MainControllerComponent,
  ) {
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });

    this.companyCode = this.webStorageService.getItemFromSessionStorage('company');
  }

  ngOnChanges(changes: any): void {
    console.log(changes);
  }
  createFields(group: any, type: any) {
    let groupedData = [];
    type?.forEach(option => {
      if (option?.items != null) {
        option.items.forEach(item => {
          this.handleFields(group, item, groupedData)
        });
      }
      else {
        this.handleFields(group, option, groupedData)
      }
    });
    this.formData[group.GroupName] = groupedData;
  }
  handleFields(group, item, groupedData) {
    const obj: any = {};
    obj.id = item.id;
    obj.name = item.name;
    obj.value = item.value;
    groupedData.push(obj);

    const newField = {
      fieldID: null,
      Name: '',
      Label: '',
      fieldType: 'Input',
      viewMode: true,
      value: '',
      isFromAPI: item.value ? true : false,
      fileAttribute: null,
      isAlphaNumeric: false,
      isEmail: false,
      isMobile: false,
      isRegex: false,
      isRequired: false,
      maxLength: null,
      minLength: null,
      pattern: '',
      dateAttribute: null,
      fieldOptions: [],
      show: false,
    };

    newField.fieldID = item.id;
    newField.Name = item.name;
    newField.Label = item.name;
    newField.value = item.value;
    newField.isRequired = true;
    newField.show = true;
    newField.viewMode = false;
    group.Fields.push(newField);
  }
  initializeFormData(isnewuserInitialize: boolean = false) {
    // Create formData model object from conf fields
    this.conf.Groups.forEach(group => {
      const groupName = group.GroupName.replaceAll(' ', '');
      if (group.IsMultiple) {
        if (group?.multipleOptions?.optionValues.length > 0) {
          group.Fields = []; // We should create fields based on group?.multipleOptions?.optionValues items and not display supplied field.
        }
        //adding phone number from form data
        if (groupName === "PhoneNumbers") {
          let phoneInfo: any = this.formDataService.getFormDataByKey("userInformation")?.PhoneNumbers;
          if (phoneInfo?.length > 0 && group?.multipleOptions?.optionValues.length > 0)
            this.createFields(group, phoneInfo);

          else
            this.createFields(group, group?.multipleOptions?.optionValues);
        }
        else {
          //other type of combinations
          this.createFields(group, group?.multipleOptions?.optionValues);
        }
      } else {
        group.Fields.forEach(field => {
          if (field.Name === 'ReadOnly') {
            field.show = false;
          }
          else {
            field.show = true;
          }
          if (field.dataSource || field.childDataSource) {
            this.getData(field);
            this.getChildData(field);
          }
          if (field.fieldType === 'CheckBox') {

            if (typeof (field.value) != 'string') {
              field.isSelected = field.value;
            } else {
              field.isSelected = field.value.toLowerCase() === 'true' ? true : false;
            }
          }
          if (isnewuserInitialize && field.Name != 'Country' && field.Name != 'Industry') {
                field.value = '';
          }
          this.formData[field.Name] = field.value;
        });
      }
    });
    this.invalidForm();
    this.showAllDependentFields();
    console.log('formData', this.formData);
  }


  getModel(group, field) {
    let model = '';
    if (group.IsMultiple) {
      model = this.formData[group.GroupName]?.find((f: any) => f.id === field.fieldID)?.value || '';
    } else {
      model = this.formData[field.Name];
    }
    //console.log("model", field.Name, model);
    return model;
  }

  setModel(groupObj, fieldObj, value) {
    if (groupObj.IsMultiple) {
      const field = this.formData[groupObj.GroupName].find((f: any) => f.id === fieldObj.fieldID);
      if (field) {
        field.value = value;
      }
    } else {
      this.formData[fieldObj.Name] = value;
    }
    fieldObj.value = value;
  }

  ngOnInit(): void {
      this.queueService.isNewUser.subscribe((val: any) => {
          if (val.cleardata) {
              this.pageonInit(true);
              this.queueService.setIsNewUser({ cleardata: false, isnewUser: false });
          }
      });
      this.pageonInit(false);

    
  }
  pageonInit(isnewuserInitialize: boolean = false) {
      this.queueService.setIsUserChange(false);
      this.loaderService.status.next(false);
      this.conf = this.formDataService.getConf(this.caseDetailsConf, this.tabName);
      var fieldsReadOnly = this.conf?.Groups[0]?.Fields?.find(item => item.Name === 'ReadOnly');
      this.conf.Groups.forEach((group: any) => {
          group.fieldsReadOnly = (fieldsReadOnly && (fieldsReadOnly.value.toLowerCase() == 'true')) ? true : false;
      })


      this.isAddNewUser = this.appService.getIsAddNewUser();
      console.log(this.isAddNewUser, 'search');
      if (this.isAddNewUser) {
          this.conf.Groups.forEach((group: any) => {
              group.Fields.forEach((field: any) => {
                  field.viewMode = false;
              });
              group.viewMode = false;
          });
      }

      if (Array.isArray(this.conf?.Groups)) {
          this.conf.Groups.forEach((group: any) => {
              group.isSave = false;
              if (Array.isArray(group?.Fields)) {
                  group.Fields.forEach((field: any) => {
                      if (typeof field['value'] === 'string') {
                          field['value'] = Utils.GetDecodedString(field['value']);
                      }
                  });
              }
          });
      }
      console.log('this.conf', this.conf);
      if (this.conf) {
          // Load cached/existing data if available
          // console.log("this.conf.TabValue + '_conf' in sessionStorage", this.conf.TabValue + '_conf' in sessionStorage)
          //if(this.conf.TabValue + '_conf' in sessionStorage){
          //  this.conf = JSON.parse(sessionStorage.getItem(this.conf.TabValue + '_conf'));
          //}
          this.initializeFormData(isnewuserInitialize);
          if (!isnewuserInitialize) {
              this.formDataService.validateForm(this.conf, this.formDataHasError);

              if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
                  this.formDataHasError.emit(true);
              }
          }
          this.emitFormData();
          this.invalidForm();
      }
      const supportedClients = ['PCH', 'BCH', 'AHP'];
      const clientAbbreviation = Utils.fetch('clientAbbreviation');
      if (supportedClients.includes(clientAbbreviation)) {
          let userType = '';
          let crmUserID = '';

          this.conf.Groups.forEach((group: any) => {
              group.Fields.forEach((field: any) => {
                  if (field.Name === 'Role') {
                      const option = field.fieldOptions?.find((opt: any) => opt.Value === field.value);
                      userType = option?.Name || '';
                  }
                  if (field.Name === 'CrmUserID') {
                      crmUserID = field.value || '';
                  }
              });
          });

          if (supportedClients.includes(clientAbbreviation) && !this.appService.getHasOpenedQNX()) 
            {
            this.openQNXTab(userType, crmUserID);
            this.appService.setHasOpenedQNX(true);
            }
         // this.openQNXTab(userType, crmUserID);
          // const fullURL = this.mainController.setItemsForQNX(userType, crmUserID);
          // this.configService.OpenUrlInNewTab(fullURL);
      }
    }
  invalidForm(){
    this.conf.Groups.forEach((group: any) => {
      group.isSave = false;
      if (Array.isArray(group?.Fields)) {
        group.Fields.forEach((field: any) => {
          if (field.invalid && field.show && !group.IsMultiple) {
            group.isSave = true;
            console.log(field.Name +" IS INVALID");
            //return;
          }

          if(group.IsMultiple && group.multipleOptions.optionValues.length == 0){
            group.isSave = true;
            if(field.isRequired && field.show && field.value != ''){
              group.isSave = false;
            }
            console.log(field.Name +" IS INVALID");
          }else if(group.IsMultiple && group.multipleOptions.optionValues.length == 1) {
              if(field.isRequired && field.show && field.value == ''){
                group.isSave = true;
              }
          }
        });
      }
    });

   
  }
  
  editForm() {
    this.isEdit = !this.isEdit;
  }

  getFormData() {
    const formData = this.formData;
    console.log('formData', formData);
  }

  emitFormData() {
    this.formDataService.updateFormData(this.conf.TabValue, this.formData);
    console.log('Updated ', this.conf.TabValue, this.formData);
    this.dialerService.setCurrentUserRecord(this.formData);
    console.log("UserInfo - CurrentRecord", this.dialerService.getCurrentUserRecord())
    this.formDataEmitter.emit(this.formData);
    //console.log("JSON.stringify(this.conf)", JSON.stringify(this.conf));
    //sessionStorage.setItem(this.conf.TabValue + '_conf', JSON.stringify(this.conf));
    this.flexStore.set(this.conf.TabValue + '_conf', JSON.stringify(this.conf));
    this.invalidForm();
    this.mainController.startVideoRecording();
  }

  addNewField(groupObj: any, optionObj: any) {
    //const group = this.conf.Groups.find(g => g.GroupName === groupObj.GroupName);
    const newField = {
      fieldID: null,
      Name: '',
      Label: '',
      fieldType: 'Input',
      viewMode: true,
      value: '',
      fileAttribute: null,
      isAlphaNumeric: false,
      isEmail: false,
      isMobile: false,
      isRegex: false,
      isRequired: false,
      maxLength: null,
      minLength: null,
      pattern: '',
      dateAttribute: null,
      fieldOptions: [],
      show: false,
      isFromAPI : false
    };

    newField.fieldID = this.formDataService.generateFieldID(this.conf);
    newField.Name = optionObj.name;
    newField.Label = optionObj.name;
    newField.isRequired = true;
    newField.show = true;
    newField.viewMode = false;

    if (groupObj.IsMultiple) {
      this.formData[groupObj.GroupName].push({ id: newField.fieldID, name: newField.Name, value: newField.value });
    } else {
      this.formData[newField.Name] = newField.value;
    }

    groupObj.Fields.push(newField);
    //groupObj.optionValues.push({name: newField.Name, value: this.formData[newField.Name]})

    console.log('this.formData', this.formData);
    console.log('this.conf', this.conf);
    this.emitFormData();
  }

  createNewField(groupObj: any, optionObj: any) {
    //const group = this.conf.Groups.find(g => g.GroupName === groupObj.GroupName);
    const newField = {
      fieldID: null,
      Name: '',
      Label: '',
      fieldType: 'Input',
      viewMode: true,
      value: '',
      fileAttribute: null,
      isAlphaNumeric: false,
      isEmail: false,
      isMobile: false,
      isRegex: false,
      isRequired: false,
      maxLength: null,
      minLength: null,
      pattern: '',
      dateAttribute: null,
      fieldOptions: [],
      show: false,
    };

    newField.fieldID = this.formDataService.generateFieldID(this.conf);
    newField.Name = optionObj.name;
    newField.Label = optionObj.value;
    newField.isRequired = true;
    newField.show = true;

    if (groupObj.IsMultiple) {
      this.formData[groupObj.GroupName].push({ id: newField.fieldID, name: newField.Name, value: newField.value });
    } else {
      this.formData[newField.Name] = newField.value;
    }
    if (groupObj.multipleOptions.optionValues[0].items.length == 1) {
      // Fields in group
      groupObj.Fields.push(newField);
    }
    //groupObj.optionValues.push({name: newField.Name, value: this.formData[newField.Name]})

    console.log('this.formData', this.formData);
    console.log('this.conf', this.conf);
    this.emitFormData();
  }

  onFormDataChange(groupObj, fieldObj, event, value) {

    let selectedValue = value;
    if (event) {
      selectedValue = event.target.value;
    }

    this.setModel(groupObj, fieldObj, selectedValue);
    this.emitFormData();
    //this.formDataService.validateField(fieldObj, event.target.value, this.formDataHasError);
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
      this.formDataHasError.emit(true);
    }
    this.invalidForm();
  }

  onDropDownChange(groupObj, fieldObj, event) {
    const selectedValue = event.target.value;
    console.log('onDropDownChange', selectedValue);
    this.setModel(groupObj, fieldObj, selectedValue);
    this.emitFormData();
    //this.formDataService.validateField(fieldObj, event.target.value, this.formDataHasError);
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
      this.formDataHasError.emit(true);
    }

    // show/hide dependent fields
    this.showAllDependentFields();

    if (fieldObj.childDataSource) {
      this.getChildData(fieldObj);
    }
    if (fieldObj.childSourceFromAdmin) {
      this.getChildDataFromConfiguration(fieldObj);
    }
    this.invalidForm()
  }

  openModal(group) {
    this.modalGroupObj = group;
    console.log('group', group);
    this.display = 'block';
  }

  onCloseHandled(group) {
    this.display = 'none';
    this.reset(group);
  }

  onMultipleOptionChange(selectedOption, group) {
    group.multipleOptions.options.forEach(option => {
      if (option.name === selectedOption.name) {
        option.Selected = !option.Selected;
      }
    });
  }

  onAddMultipleOption(group) {
    group.multipleOptions.options.forEach(element => {
      if (element.Selected) {
        this.addNewField(group, element);
        group?.multipleOptions?.optionValues.push(element);
        }
    });
    this.onCloseHandled(group);
  }

  reset(group) {
    group.multipleOptions.options.forEach(option => {
      option.Selected = false;
    });
  }

  showDialog() {
    this.visible = true;
  }

  addNewFieldGroup(group) {
    const fieldGroup = [];
    if (group.multipleOptions.length > 0) {
      group.multipleOptions.optionValues[0].items.forEach((item, index) => {
        const newField = {
          fieldID: null,
          Name: '',
          Label: '',
          fieldType: 'Input',
          viewMode: true,
          value: '',
          fileAttribute: null,
          isAlphaNumeric: false,
          isEmail: false,
          isMobile: false,
          isRegex: false,
          isRequired: false,
          maxLength: null,
          minLength: null,
          pattern: '',
          dateAttribute: null,
          fieldOptions: [],
        };

        newField.fieldID = this.formDataService.generateFieldID(this.conf) + index + 1;
        newField.Name = item.name;
        newField.Label = item.name;
        newField.isRequired = true;
        fieldGroup.push(newField);
      });
      console.log('fieldGroup', fieldGroup);
      group.Fields.push(fieldGroup);
    }
  }

  editGroupFields(group: any) {
    
    group.viewMode = !group.viewMode;
    //getUserType
    let type = ''
    group.Fields.forEach((field: Field) => {
      if (field.Name === 'Role') {
        type = field.value
      }

    });

    //let isAddNewUser = this.appService.getIsAddNewUser();

    //if((this.companyCode==='Baycare' || this.companyCode==='Parkland'))
    //{
    //  group.Fields.forEach((field: Field) => {
    //    if(field.Name==='Phone' || field.Name==='Business' || field.Name==='Fax' || field.Name==='Pager' || field.Name==='Mobile')
    //    {
    //      field.viewMode = group.viewMode;
    //    }
    //    else
    //    {
    //       if (!group.viewMode) /*isAddNewUser &&*/
    //      {
    //        field.viewMode = false;
    //      }
    //      else
    //      {  
    //        field.viewMode = true;
    //      }
    //    }
    //  });
    //}
    //else{

    group.Fields.forEach((field: Field) => {
      field.viewMode = group.viewMode;
      if (group.GroupName == 'PhoneNumbers') {
        field.isFromAPI = true;
        group.fieldsReadOnly = false;
      }
    });
    // if (group.GroupName == 'PhoneNumbers' && this.fieldsReadOnly == true) {
    //   this.fieldsReadOnly = false;
    //  }
    /*}*/
  }

  getSelectedOption(field, value) {
    let targetOption: any = {};
    field.fieldOptions.forEach(option => {
      if (option.Value == value) {
        targetOption = option;
      }
    });
    return targetOption;
  }

  showAllDependentFields() {
    const clientAbbreviation = Utils.fetch('clientAbbreviation');

    var usertypedetails = this.conf.Groups[0].Fields.find(item => item.Name === 'Role');
    var isuserTypeavailable = true;
    if (usertypedetails && usertypedetails?.value == '' && (clientAbbreviation == 'BCH' || clientAbbreviation == 'PCH' || clientAbbreviation == 'AHP')) {
      isuserTypeavailable = false;
    }
    if (isuserTypeavailable) {
      this.conf.Groups.forEach(group => {
        group.Fields.forEach(field => {
          if (field.parent && field.parentFieldOption) {
            // Is dependent
            field.show = false;
            field.parent.parentFields.forEach(item => {
              const parentField: any = this.getFieldByID(item.fieldID);
              const selectedOption = this.getSelectedOption(parentField, parentField.value);
              //To which option the field is dependent?
              let depends = false;
              field?.parentFieldOption?.parentFieldOption.forEach(item => {
                if (item.fieldOptionID == selectedOption.FieldOptionID) {
                  depends = true;
                  // console.log(field.Name + ' is dependent on ' + parentField.Name + ' : ' + parentField.value);
                }
              });
              if (depends) {
                field.show = true;
              }
            });
          }
        });
      });
    }
    else {
      //this.conf.Groups.forEach(group => {
      //    if (group?.GroupName != 'PhoneNumbers')
      //        group.Fields.forEach(field => {
      //        if (!field.show)
      //        field.show = true;
      //    });
      //});
    }
    //console.log('showAllDependentFields - conf', this.conf);
  }

  getData(fieldObj) {
    if (fieldObj.parentSourceFromAdmin) {
      this.getParentDataFromConfiguration(fieldObj);
    }
    else if (fieldObj.dataSource) {
      this.formDataService.getData(fieldObj.dataSource).subscribe(response => {
        //console.log("getData response", response.Response.Data);
        fieldObj.fieldOptions = response.Response.Data;
      });
    }
  }
  getParentDataFromConfiguration(fieldObj) {
    fieldObj.fieldOptions = [];
    if (fieldObj.value) {
      let payload = {
        queueID: this.queueService.getselectedQueueId(),
        activityID: this.activityId,
        fieldID: fieldObj.fieldID,
        currentID: fieldObj.value,
        type: "TMUserInfo",
        company: this.webStorageService.getItemFromSessionStorage('company')
      };
      this.queueService.getParentDataSource(payload).subscribe(response => {
        fieldObj.fieldOptions = response.Response.Data;
      });
    }
  }
  getChildData(fieldObj) {
    const childFieldID = fieldObj.children.childFields[0].fieldID;
    const childField: any = this.getFieldByID(childFieldID);
    childField.fieldOptions = [];
    if (fieldObj.value && fieldObj.childDataSource) {
      this.formDataService.getData(fieldObj.childDataSource + fieldObj.value).subscribe(response => {
        console.log('getData response', response.Response.Data);
        childField.fieldOptions = response.Response.Data;
      });
    }
  }

  getFieldByID(fieldID) {
    let targetField = {};
    this.conf.Groups.forEach(group => {
      group.Fields.forEach(field => {
        if (fieldID == field.fieldID) {
          targetField = field;
        }
      });
    });
    return targetField;
  }
  getChildDataFromConfiguration(fieldObj) {
    let childFieldID = fieldObj.children?.childFields[0].fieldID;
    let childField: any = this.getFieldByID(childFieldID);
    childField.fieldOptions = [];
    if (fieldObj.value) {
      let payload = {
        queueID: this.queueService.getselectedQueueId(),
        activityID: this.activityId,
        fieldID: fieldObj.fieldID,
        fieldName: fieldObj.Name,
        parentValue: fieldObj.value,
        type: "TMUserInfo"
      }
      this.queueService.getDependantDataSource(payload).subscribe(response => {
        childField.fieldOptions = response.Response.Data;
      });
    }
  }

  onCheckBoxChange(groupObj, fieldObj, event) {
    //debugger;
    groupObj.Fields.forEach(field => {
      if (field.fieldType === 'CheckBox' && field.Name !== fieldObj.Name) {
        field.isSelected = false;
        this.formData[field.Name] = false;
        this.formData[field.children?.childFields[0].fieldName] = "";
      }
    })

    fieldObj.isSelected = !fieldObj.isSelected;

    //Validate child
    groupObj.Fields.forEach(field => {
      if (field.Name === fieldObj.children?.childFields[0].fieldName) {
        field.isRequired = fieldObj.isSelected;
      }
    })

    this.onFormDataChange(groupObj, fieldObj, null, fieldObj.isSelected);
    this.initializeFormData();
    // this.setModel(groupObj, fieldObj, fieldObj.isSelected);
    // this.emitFormData();
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    if (this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)) {
      this.formDataHasError.emit(true);
    }
    // this.updateDispositionPayload(fieldObj.Name);
    this.invalidForm()
  }

  deleteField(groupObj, fieldObj) {
    groupObj.Fields = groupObj.Fields.filter(fd => {
      return fd.fieldID != fieldObj.fieldID
    })
    this.formData[groupObj.GroupName] = this.formData[groupObj.GroupName].filter(fd => {
      return fd.id != fieldObj.fieldID;
    })
    this.invalidForm();
  }

  changeUser() {
    this.mainController.setIsCaseUserUnmapped(null);
    this.mainController.setIsUnknownContact(false);
    this.queueService.setIsUserChange(true);
    this.ConfirmUserNav.emit(true);
    this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/ConfirmUser']);
  }
  onCalendarDateSelected(group: any, field: any, event: any) {
    field.value = event.date;
    this.onFormDataChange(group, field, null, event.date);
    this.appService.setDateTimePickerData({
      tabName: "userInformation",
      fieldName: field.Name,
      caseId: null,
      dateValue: event.date,
      convertedDateValue: new Date(event.date)
    });
  }
    getIsReadOnlyCase() {
        return this.mainController.getIsReadOnlyCase();
    }
  openQNXTab(userType: string, crmUserID: string): void {
     const allowPopUps = this.webStorageService.getItemFromSessionStorage('loginParams')?.AllowPopUps ?? true;
    if(!allowPopUps){
     return;
    }
    let qnxTab: Window | null = null;
    let hasOpenedFallbackTab = false;

    let url = this.mainController.setItemsForQNX(userType, crmUserID);

    if (url) {
      const clientAbbreviation = Utils.fetch('clientAbbreviation');
      if (this.WindowsWrapper.IsWrapper() && (clientAbbreviation == 'BCH' || clientAbbreviation == 'PCH' || clientAbbreviation == 'AHP')) {
        url = 'cr' + url;
        this.WindowsWrapper.EnableCRProtocol(true);
      }
      const isFallback = url.endsWith('/QNXT/');
      if (isFallback) {
        
        // Scenario 1: First time, no CRM ID
        if (!hasOpenedFallbackTab) {
          
          qnxTab = window.open(url, 'QNXDeepLinkTab');
          
          hasOpenedFallbackTab = true;
        } else {
          // Scenario 3: No CRM ID, but fallback already opened
          console.log('Fallback tab already opened — not opening again');
        }
      } else {
        // Scenario 2: CRM ID is present
          if (!qnxTab || qnxTab.closed) {
              qnxTab = window.open(url, 'QNXDeepLinkTab');
          } else {
            qnxTab.location.href = url;
            qnxTab.focus();
          }
        
      }
    }
  }
}
